import {
  Anchor,
  Card,
  Flex,
  FONT_TYPES,
  mediaMixin,
  spaceMixin,
  Table,
  Text,
  typographyMixin,
} from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledCenterText = styled.div`
  text-align: center;
`;

export const StyledRow = styled(Table.Row)`
  cursor: pointer;
  vertical-align: middle;
`;

export const StyledFullWidthDiv = styled(Flex)`
  width: 100%;
`;

export const StyledAnchor = styled(Anchor)`
  text-decoration: none;
  color: inherit;
  cursor: auto;

  &:visited,
  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
    color: black;
    outline: 0;
    cursor: pointer;
  }
`;

const getResponsiveMaxWidth = () => {
  return css`
    margin: 0 auto;
    max-width: 608px;
  `;
};

export const StyledEmptySimpleCard = styled(Card)`
  padding-top: ${spaceMixin(5)};
  padding-bottom: ${spaceMixin(5)};
  padding-left: ${spaceMixin('md')};
  padding-right: ${spaceMixin('md')};
`;

export const StyledEmptyStateContainer = styled.div`
  text-align: center;
  ${getResponsiveMaxWidth}
`;

export const StyledEmptyIconContainer = styled.div`
  margin-bottom: ${spaceMixin('xs')};
`;

export const StyledEmptyTitleText = styled(Text)`
  margin-bottom: ${spaceMixin('xs')};

  ${(props) => typographyMixin({ ...props, fontType: FONT_TYPES.h5 })}

  ${mediaMixin(
    'md',
    css`
      ${(props) => typographyMixin({ ...props, fontType: FONT_TYPES.h4 })}
    `,
  )}
`;

export const StyledEmptyContentBodyText = styled(Text)`
  display: block;
  margin-bottom: ${spaceMixin('md')};

  ${(props) => typographyMixin({ ...props, fontType: FONT_TYPES.body })}
`;
